import { useQueryClient } from "@tanstack/react-query";
import {
  INITIAL_EM_CONTACT,
  INITIAL_PATIENT_INSURANCE,
} from "../../../../../../../constants/provider/patient/add-new-patient/add-new-patient-form";
import { DisclosureHost } from "../../../../../../../hooks/use-disclosure";
import { PatientInsurance } from "../../../../../../../services";
import {
  getValueFromObj,
  transformMultiSelectFrontEndVal,
} from "../../../../../../../utils/utils";
import { AddNewPatientTab } from "../../../UpsertPatientForm";
import UpdatePatientForm from "../../../UpdatePatientForm";
import StyledFormModal from "../../../../../../../components/globalModal/StyledModal";

interface UpsertPatientFormDrawerProps {
  disclosureHost: DisclosureHost;
  patientData?: any;
  preSelectedTab?: AddNewPatientTab;
}

const UpsertPatientFormDrawer = ({
  disclosureHost,
  patientData,
  preSelectedTab: _preselectedTab,
}: UpsertPatientFormDrawerProps) => {
  const queryClient = useQueryClient();

  const prefillValues = {
    ...patientData,
    emergencyContacts: patientData?.emergencyContacts?.length
      ? patientData?.emergencyContacts
      : INITIAL_EM_CONTACT,
    patientInsurances: patientData?.patientInsurances?.length
      ? patientData?.patientInsurances.map(
          (singleInsurance: PatientInsurance) => ({
            ...singleInsurance,

            provider:
              singleInsurance?.provider &&
              Object.keys(singleInsurance?.provider)?.length
                ? {
                    value: Object.keys(singleInsurance.provider)?.[0],
                    label: getValueFromObj(singleInsurance.provider),
                  }
                : undefined,
            planId: singleInsurance?.planId
              ? {
                  value: singleInsurance?.planId,
                  label: singleInsurance?.planName,
                }
              : undefined,
            insurancePayer: {
              payerId: {
                value: singleInsurance?.insurancePayer?.payerId,
                label: singleInsurance?.insurancePayer?.payerName ?? "",
              },
            },
          })
        )
      : [INITIAL_PATIENT_INSURANCE],
    languages: transformMultiSelectFrontEndVal(
      [{ uuid: "", name: "" }],
      patientData?.languages
    ),
  };

  const handleClose = () => {
    disclosureHost.close();
  };

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={handleClose}
      dialogTitle="Edit Patient Details"
      sx={{
        "& .MuiDialog-paper": {
          width: "50vw",
          height: "80vh",
        },
      }}
    >
      <UpdatePatientForm
        closeDrawer={() => {
          queryClient.invalidateQueries({
            queryKey: ["provider-group-patients-list"],
          });
          queryClient.invalidateQueries({
            queryKey: ["patient"],
          });
          disclosureHost.close();
        }}
        prefillValues={prefillValues as any}
        onCancel={() => disclosureHost.close()}
      />
    </StyledFormModal>
  );
};

export default UpsertPatientFormDrawer;
